/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import Link from './Link';
import {createURLWithParams} from '../util';
import Button, {ButtonTypes} from './ButtonNew';

const serviceTags = {
  resume: {
    id: 'resume',
    type: 'service',
    title: 'Get your resume reviewed by a FAANG recruiter',
    description: 'Tailor your resume for the job you want and get honest feedback',
    cta: 'Upload now ->',
    url: '/resume',
  },
  referrals: {
    id: 'referrals',
    type: 'service',
    title: 'Get job referrals to top companies',
    description: 'Land more interviews with job referrals from employees at Google, Facebook, Amazon, and more.',
    cta: 'Get a referral ->',
    url: '/jobs/referrals',
  },
  negotiation: {
    id: 'negotiation',
    type: 'service',
    title: 'Increase your offer with our expert negotiators',
    description: 'Maximize your offer with a professional negotiator for as much as $100k more',
    cta: 'Learn more ->',
    url: '/coaching?category=negotiation',
  },
};

const ServiceCard = ({tag, trackerEvent, urlParams}) => {
  const {
    title, description, cta, url,
  } = serviceTags[tag?.id] || {};
  const link = createURLWithParams(url, urlParams);

  const handleClick = () => {
    trackerEvent?.();
  };

  return (
    <div
      className="-mx-2 cursor-pointer mt-4 py-4 px-4 border border-gray-200 rounded-lg"
      onClick={handleClick}
    >
      <Link href={url}>
        <h3 className="text-lg font-semibold mb-1 leading-tight tracking-tight">
          {title}
        </h3>
      </Link>
      <div className="text-sm text-gray-500 font-regular mb-3">
        {description}
      </div>
      <Button
        onClick={handleClick}
        href={link}
        target="_blank"
        buttonType={ButtonTypes.SECONDARY}
        className="w-full"
      >
        {cta}
      </Button>
    </div>
  );
};

export default ServiceCard;
